import { OnSchedRest }          from '../../OnSchedRest'
import { OnSchedHelpers }       from '../../utils/OnSchedHelpers';
import { OnSchedWizardHelpers } from '../../utils/WizardHelpers/OnSchedWizardHelpers'


export const CreateResource = (element, response) => {
  if (response.error) {
      OnSchedHelpers.ThrowError(element, response);
      return;
  }

  // Add allocations
  if (element.options.allocations) {                      
    let newAllocations = [];
    document.querySelectorAll('[data-post="allocations"]').forEach(a => newAllocations.push(Object.assign({}, a.dataset)));
    
    const requests = newAllocations.map(allocationData => new Promise(resolve => {
        const allocationsUrl = element.onsched.setupApiBaseUrl + '/resources/' + response.id + '/allocations';
        const allocationPayload = {
            locationId: OnSchedHelpers.IsEmpty(allocationData.locationid) ? '' : allocationData.locationid,
            startDate: allocationData.startdate,
            endDate: allocationData.enddate,
            startTime: allocationData.starttime,
            endTime: allocationData.endtime,
            reason: allocationData.reason,
            repeats: allocationData.repeats === "true",
            repeat:{
                frequency: allocationData.frequency,
                interval: parseInt(allocationData.interval),
                weekdays: allocationData.weekdays,
                monthDay: allocationData.startdate.slice(-2),
                monthType: "D"
            }
        }

        OnSchedRest.Post(allocationsUrl, allocationPayload, allocationResp => {
            resolve(allocationResp);
        })
    }))

    Promise.all(requests)
  }
  

  // Add blocks
  if (element.options.blocks) {                      
    let newBlocks = [];
    document.querySelectorAll('[data-post="blocks"]').forEach(a => newBlocks.push(Object.assign({}, a.dataset)));
    
    const requests = newBlocks.map(allocationData => new Promise(resolve => {
        const blocksUrl = element.onsched.setupApiBaseUrl + '/resources/' + response.id + '/block';
        const blockPayload = {
            locationId: OnSchedHelpers.IsEmpty(allocationData.locationid) ? '' : allocationData.locationid,
            startDate: allocationData.startdate,
            endDate: allocationData.enddate,
            startTime: allocationData.starttime,
            endTime: allocationData.endtime,
            reason: allocationData.reason,
            repeats: allocationData.repeats === "true",
            repeat:{
                frequency: allocationData.frequency,
                interval: parseInt(allocationData.interval),
                weekdays: allocationData.weekdays,
                monthDay: allocationData.startdate.slice(-2),
                monthType: "D"
            }
        }

        OnSchedRest.Post(blocksUrl, blockPayload, blockResp => {
            resolve(blockResp);
        })
    }))

    Promise.all(requests)
  }
  
  // Open pop-up for calendar auth
  if (response.googleCalendarId) {
    window.open(response.googleCalendarAuthUrl, 'Onsched Google Authorization', "height=400,width=400");
  }
  if (response.outlookCalendarId) {
    window.open(response.outlookCalendarAuthUrl, 'Onsched Outlook Authorization', "height=400,width=400");
  }

  // check if we need to upload an image for this resource
  const elSystemFileUploadBtn = document.querySelector(".onsched-wizard.onsched-form input[name=onsched-system-file-upload]");
  if (elSystemFileUploadBtn.value) {

      var image = document.getElementById("onsched-image-preview");
      const base64String = OnSchedWizardHelpers.Base64Encoded(image); 

      var postData = { imageFileName:elSystemFileUploadBtn.dataset.filename, imageFileData: base64String};
      console.log(postData);
      const uploadImageUrl = element.onsched.setupApiBaseUrl + "/resources/"+ response.id + "/uploadimage";

      OnSchedRest.Post(uploadImageUrl, postData, function (response) {
          if (response.error) {
              OnSchedHelpers.ThrowError(element, response);
              return;
          }
      })
  }

  console.log("OnSchedResponse.PostResource");
  console.log(response);
  var elResourceSetup = document.getElementById(element.id);
  var confirmationEvent = new CustomEvent("resourceSetupComplete", { detail: response });
  elResourceSetup.dispatchEvent(confirmationEvent);    
}

export const ModifyResource = (element, response) => {
    if (response.error) {
        // Error on PUT /resource
        OnSchedHelpers.ThrowError(element, response);
    }
    else {
        var elResourceSetup = document.getElementById(element.id);
        var confirmationEvent = new CustomEvent("resourceSetupComplete", { detail: response });

        OnSchedHelpers.UtilityCustomEvents.ElementLoaded(element);
        
        // Check if we need to upload an image
        const checkImgUpload = () => new Promise(resolve => {
            const imageData = OnSchedHelpers.FormatImageData();
            
            if (imageData.upload) {
                // Resolve after image upload
                const uploadImageUrl = element.onsched.setupApiBaseUrl + "/resources/"+ response.id + "/uploadimage";
                
                OnSchedRest.Post(uploadImageUrl, imageData, function (imgResponse) {
                    resolve(null)
    
                    if (imgResponse.error) {
                        console.log("PostResourceImage Rest error response code=" + imgResponse.code);
                    }
                })
            }
            else {
                // Resolve no image upload
                resolve(null)
            }
        })

        // Check if we need to authorize calendar
        const checkCalendarAuth = () => new Promise(resolve => {
            const calendarProviders = { 0: 'OnSched', 1: 'Google', 2: 'Outlook' };

            // Check if response has value for google or outlook id
            if ((response.googleCalendarId && response.googleCalendarId.length) || 
                (response.outlookCalendarId && response.outlookCalendarId.length)) {
                // Check if calendarAvailability is google or outlook
                if (response.calendarAvailability === 1 || response.calendarAvailability === 2) {
                    if (document.getElementById('externalCalendarId')) {
                        const calendarId = document.getElementById('externalCalendarId');
                        const externalCalProvider = calendarProviders[response.calendarAvailability].toLowerCase();

                        // Check if Calendar ID is different than previous
                        if (calendarId.dataset.authorizedcalendar !== response[externalCalProvider + 'CalendarId']) {
                            // Need to authorize, Calendar ID is new
                            window.open(response[externalCalProvider + 'CalendarAuthUrl'], "_blank", "height=700,width=500,location=0,menubar=0");
                            resolve(null)
                        }
                        // No need to authorize, Calendar ID has not changed
                        else resolve(null)
                    }
                    // Cannot find externalCalendarId element
                    else resolve(null)
                }
                // Calendar availability set to None
                else resolve(null)
            }
            // No Calendar ID, this will unauthorize resource
            else resolve(null)
        })

        checkImgUpload()
            .then(checkCalendarAuth)
            .then(() => {
                elResourceSetup.dispatchEvent(confirmationEvent); 
                elResourceSetup.innerHTML = "";
            })
    }
    
    return;
}    
